export default [{
    path: '/magazine',
    component: ()=> import("@/views/Magazine"),
    meta:{
        title:"电子杂志"
    },
    children:[]
},
{
    path: '/magazineDetailChild',
    component: ()=> import("@/views/MagazineDetailChild"),
    meta:{
        title:"电子杂志"
    },
    children:[]
}


]